module.exports = __webpack_public_path__ + "img/jtxrw2.dd82366f.png";